import { createReducer } from "@reduxjs/toolkit";
import { POSTS_GET_ALL, POSTS_ADD, POSTS_DELETE, POSTS_UPDATE } from "./action";
import { Post } from "src/types/post";

export type PostState = {
  posts: Post[];
};

export const initialState: PostState = {
  posts: [],
};

const postReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(POSTS_GET_ALL, (state, action) => {
      state.posts = action.payload.posts;
    })
    .addCase(POSTS_ADD, (state, action) => {
      state.posts.push(action.payload.post);
    })
    .addCase(POSTS_DELETE, (state, action) => {
      state.posts = state.posts.filter(
        (p) => p.postId !== action.payload.postId
      );
    })
    .addCase(POSTS_UPDATE, (state, action) => {
      const updatedPost = action.payload.post;
      const index = state.posts.findIndex((p) => p.postId === updatedPost.postId);
      if (index !== -1) {
        state.posts[index] = updatedPost;
      }
    })
);

export default postReducer;
